<template>
  <el-container class="layout">
    <el-aside width="210px" class="aside">
      <div class="logo"></div>
      <el-menu
        class="menu"
        :default-active="activeMenu"
        router
        background-color="#fff"
        text-color="rgb(51, 51, 51)"
        active-text-color="#FF7946"
      >
        <el-menu-item index="/training">
          <i class="el-icon-s-order"></i>
          <span slot="title">培训列表</span>
        </el-menu-item>
        <el-menu-item index="/course">
          <i class="el-icon-notebook-2"></i>
          <span slot="title">课程目录</span>
        </el-menu-item>
        <el-menu-item index="/video">
          <i class="el-icon-video-play"></i>
          <span slot="title">视频学习</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header" height="60px">
        <div></div>
        <!-- <span class="page-title">{{ pageTitle }}</span> -->
        <el-dropdown @command="handleCommand">
          <span class="user">
            <i class="el-icon-user"></i>
            {{ userName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getUser, clearAuth } from '../utils/auth'

export default {
  name: 'Layout',
  computed: {
    userName() {
      const u = getUser() || {}
      return u.em_name || u.em_names || u.account || '用户'
    },
    activeMenu() {
      return this.$route.path
    },
    pageTitle() {
      return (
        this.$route.query.title ||
        (this.$route.meta && this.$route.meta.title) ||
        '安全培训学习平台'
      )
    }
  },
  methods: {
    handleCommand(cmd) {
      if (cmd === 'logout') {
        this.$confirm('确定退出登录吗？', '提示', { type: 'warning' })
          .then(() => {
            clearAuth()
            this.$router.replace('/login')
          })
          .catch(() => {})
      }
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
}

.aside {
  background: #fff;
  overflow-x: hidden;
}

.logo {
  height: 60px;
  line-height: 60px;
  text-align: center;
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  background: #fff;
}

.menu {
  border-right: none;
}

.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
}

.page-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.user {
  cursor: pointer;
  color: #303133;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 4px;
  outline: none;
}

.main {
  background: #f5f7fa;
  padding: 16px;
}
</style>
